import { apiRequest } from '../../api-client';

export interface AddUserToEnterpriseParams {
  token: string;
  enterpriseId: string;
  email: string;
  firstName: string;
  lastName: string;
  isEnterpriseAdmin: boolean;
  products: Record<string, boolean>;
  productAdmins: Record<string, boolean>;
  sendEmail: boolean;
}

export interface AddUserResult {
  subscriptionsAdded?: string[];
  errors?: string[];
}

/**
 * Add a user to an existing enterprise.
 * POST /api-internal/enterprise/:enterprise_id/add-user
 */
export function addUserToEnterprise({
  token,
  enterpriseId,
  email,
  firstName,
  lastName,
  isEnterpriseAdmin,
  products,
  productAdmins,
  sendEmail
}: AddUserToEnterpriseParams): Promise<AddUserResult> {
  return apiRequest<AddUserResult>({
    method: 'POST',
    endpoint: `/api-internal/enterprise/${enterpriseId}/add-user`,
    token,
    body: {
      email,
      firstName,
      lastName,
      isEnterpriseAdmin,
      products,
      productAdmins,
      sendEmail
    }
  });
}
